import { commonFilter } from './filter';

export default (pageName: string, pagePath: string) => ({
  pageName,
  pageId: '20113',
  pagePath,
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
});
